import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../../lib/formatPrice';

interface ProductCardProps {
    id: string;
    title: string;
    price: string | number;
    image: string;
    brand?: string;
    linkPrefix: string;
    discountPercent?: number;
    oldPrice?: string | number;
}

const ProductCard: React.FC<ProductCardProps> = ({ id, title, price, image, brand, linkPrefix, discountPercent, oldPrice }) => {
    return (
        <div className="bg-white border rounded-lg overflow-hidden group hover:shadow-xl transition-all duration-300 relative">
            {discountPercent && (
               <div className="absolute top-2 right-2 bg-red-600 text-white font-bold text-xs px-2 py-1 rounded">
                   %{discountPercent}
               </div>
            )}
            
            <Link to={`${linkPrefix}/${id}`} className="block h-48 sm:h-64 overflow-hidden relative p-4">
                 <img 
                    src={image} 
                    alt={title} 
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" 
                 />
            </Link>

            <div className="p-4 border-t">
                {brand && (
                    <div className="text-xs text-gray-500 mb-1 uppercase tracking-wider">{brand}</div>
                )}
                <Link to={`${linkPrefix}/${id}`}>
                    <h3 className="text-gray-800 font-medium text-sm sm:text-base leading-tight mb-2 min-h-[40px] hover:text-blue-600 transition-colors">
                        {title}
                    </h3>
                </Link>
                
                <div className="mt-2">
                    {oldPrice && (
                        <div className="text-gray-400 text-xs line-through">{formatPrice(oldPrice)} ₺</div>
                    )}
                    <div className="text-blue-900 font-bold text-lg">{formatPrice(price)} ₺</div>
                </div>

                {/* Optional: Add to cart button or Detail button */}
                <div className="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Link 
                        to={`${linkPrefix}/${id}`}
                        className="w-full text-center bg-[#002744] text-white text-sm py-2 rounded hover:bg-blue-800 transition-colors"
                    >
                        İncele
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
